module.exports = __webpack_public_path__ + "img/pazar-forushgahi.7c488c27.jpg";